import { $ } from "jquery";
import "@/application/images/home/lookup/domainagents.png";
import { initDomainLookup } from "@/checkout/lookup/domain_lookup";

window.$ = window.jQuery = $;
const node = document.getElementById("app");

initDomainLookup(node, JSON.parse(node.getAttribute("data-props")));
